/* SHOPX — Bubble Falls: all theme behaviour. No libraries. */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      var fmt = window.BFShop && window.BFShop.moneyFormat;
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      if (fmt) return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
      return '$' + amount;
    } catch (e) { return ''; }
  };

  /* ---------- mobile nav ---------- */
  function initNav() {
    document.querySelectorAll('[data-bf-burger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.querySelector('[data-bf-nav]');
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-bf-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-bf-gallery-main]');
      if (!main) return;
      gal.querySelectorAll('[data-bf-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) { main.setAttribute('src', src); main.setAttribute('alt', alt); }
          gal.querySelectorAll('[data-bf-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- quantity ---------- */
  function initQty() {
    document.querySelectorAll('[data-bf-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var step = parseInt(b.getAttribute('data-step'), 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants() {
    document.querySelectorAll('[data-bf-variants]').forEach(function (root) {
      var idInput = document.querySelector(root.getAttribute('data-target'));
      root.querySelectorAll('[data-variant-id]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.hasAttribute('disabled')) return;
          root.querySelectorAll('[data-variant-id]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var nm = btn.getAttribute('data-name'), nmEl = root.querySelector('[data-bf-swatch-name]');
          if (nm && nmEl) nmEl.textContent = nm;
          var id = btn.getAttribute('data-variant-id');
          if (idInput) idInput.value = id;
          document.querySelectorAll('[data-bf-variant-input]').forEach(function (i) { i.value = id; });

          var price = btn.getAttribute('data-price');
          if (price) {
            document.querySelectorAll('[data-bf-price]').forEach(function (el) { el.textContent = money(parseInt(price, 10)); });
            document.querySelectorAll('[data-bf-atc-total]').forEach(function (el) {
              el.setAttribute('data-unit', price);
              el.dispatchEvent(new Event('bf:unit'));
            });
          }
          var img = btn.getAttribute('data-image');
          var main = document.querySelector('[data-bf-gallery-main]');
          if (img && main) main.setAttribute('src', img);
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', id);
            window.history.replaceState({}, '', url.toString());
          } catch (err) {}
        });
      });
    });
  }

  /* ---------- live total inside the add-to-bag button ---------- */
  function initAtcTotal() {
    document.querySelectorAll('form[data-bf-atc]').forEach(function (form) {
      var out = form.querySelector('[data-bf-atc-total]');
      if (!out) return;
      var qty = form.querySelector('input[name="quantity"]');
      var update = function () {
        var unit = parseInt(out.getAttribute('data-unit'), 10) || 0;
        var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
        var pct = parseFloat(out.getAttribute('data-discount')) || 0;
        var extra = 0;
        form.querySelectorAll('[data-bf-addon]:checked').forEach(function (a) { extra += parseInt(a.getAttribute('data-price'), 10) || 0; });
        out.textContent = money(Math.round(unit * q * (1 - pct / 100)) + extra);
      };
      if (qty) { qty.addEventListener('change', update); qty.addEventListener('input', update); }
      form.querySelectorAll('[data-bf-addon]').forEach(function (a) { a.addEventListener('change', update); });
      out.addEventListener('bf:unit', update);
    });
  }

  /* ---------- electrode picker ---------- */
  function initElectrodes() {
    document.querySelectorAll('[data-bf-electrodes]').forEach(function (root) {
      root.querySelectorAll('[data-el-index]').forEach(function (row) {
        row.addEventListener('click', function () {
          var i = row.getAttribute('data-el-index');
          root.querySelectorAll('[data-el-index]').forEach(function (r) { r.classList.remove('is-active'); });
          row.classList.add('is-active');
          root.querySelectorAll('[data-el-pane]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-el-pane') === i);
          });
          root.querySelectorAll('[data-el-pic]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-el-pic') === i);
          });
        });
      });
    });
  }

  /* ---------- added-to-bag card ---------- */
  var ICON_OK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';
  var ICON_ERR = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M8 4v5M8 11.5v.5"/></svg>';
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var bfToastEl = null;

  function bfHideToast() {
    if (!bfToastEl) return;
    bfToastEl.classList.remove('is-open');
  }

  function bfToast(html, isError) {
    if (!bfToastEl) {
      bfToastEl = document.createElement('div');
      bfToastEl.className = 'bf-toast';
      bfToastEl.setAttribute('role', 'status');
      bfToastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(bfToastEl);
      bfToastEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-bf-toast-close]')) bfHideToast();
        var up = e.target.closest('[data-bf-up-add]');
        if (up) bfUpsellAdd(up);
      });
      bfToastEl.addEventListener('animationend', function (e) {
        if (e.target.classList.contains('bf-toast__bar')) bfHideToast();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') bfHideToast(); });
    }
    bfToastEl.classList.remove('is-open');
    bfToastEl.classList.toggle('is-error', !!isError);
    bfToastEl.innerHTML = html + '<span class="bf-toast__bar" aria-hidden="true"></span>';
    void bfToastEl.offsetWidth; /* restart animations */
    bfToastEl.classList.add('is-open');
  }

  function bfShowAdded(item, cart) {
    var count = cart ? cart.item_count : 0;
    var meta = [];
    if (item && item.variant_title && item.variant_title !== 'Default Title') meta.push(esc(item.variant_title));
    if (item) meta.push('Qty ' + item.quantity);
    var img = item && (item.featured_image && item.featured_image.url || item.image);
    if (img && img.indexOf('data:') !== 0) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    var html =
      '<div class="bf-toast__head">' +
        '<span class="bf-toast__ico">' + ICON_OK + '</span>' +
        '<span class="bf-toast__ttl">Added to your bag</span>' +
        '<button type="button" class="bf-toast__x" data-bf-toast-close aria-label="Close">&times;</button>' +
      '</div>' +
      (item ?
      '<div class="bf-toast__item">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56">' : '<span class="bf-toast__ph"></span>') +
        '<div class="bf-toast__info"><div class="bf-toast__name">' + esc(item.product_title) + '</div>' +
        '<div class="bf-toast__meta">' + meta.join(' · ') + '</div></div>' +
        '<div class="bf-toast__price">' + money(item.final_line_price) + '</div>' +
      '</div>' : '') +
      (cart ?
      '<div class="bf-toast__sum"><span>Bag subtotal · ' + count + ' item' + (count === 1 ? '' : 's') + '</span><b>' + money(cart.total_price) + '</b></div>' : '') +
      bfUpsellHtml(cart) +
      '<div class="bf-toast__cta">' +
        '<a class="bf-toast__btn" href="/cart">View bag</a>' +
        '<a class="bf-toast__btn bf-toast__btn--dark" href="/checkout">Checkout</a>' +
      '</div>';
    bfToast(html, false);
  }

  /* "Pairs well" row — product set on the PDP hero (window.BFShop.upsell) */
  function bfUpsellHtml(cart) {
    var u = null; /* add-on upsell removed */
    if (!u || !u.id) return '';
    if (cart && cart.items && cart.items.some(function (li) { return String(li.variant_id) === String(u.id); })) return '';
    return '<div class="bf-toast__up">' +
      (u.image ? '<img src="' + esc(u.image) + '" alt="" width="44" height="44">' : '<span></span>') +
      '<div><div class="bf-toast__upk">' + esc(u.kicker || 'Pairs well') + '</div><div class="bf-toast__upn">' + esc(u.title) + '</div></div>' +
      '<button type="button" class="bf-toast__upb" data-bf-up-add="' + esc(u.id) + '">Add · ' + money(u.price) + '</button>' +
    '</div>';
  }

  function bfUpsellAdd(btn) {
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-bf-up-add'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (added) {
        var item = added && added.items ? added.items[0] : added;
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-bf-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          var hit = cart.items.filter(function (li) { return li.variant_id === item.variant_id; })[0] || item;
          bfShowAdded(hit, cart);
        });
      })
      .catch(function () { bfShowError('Could not add — please try again'); });
  }

  function bfShowError(text) {
    bfToast(
      '<div class="bf-toast__head">' +
        '<span class="bf-toast__ico">' + ICON_ERR + '</span>' +
        '<span class="bf-toast__ttl">' + esc(text) + '</span>' +
        '<button type="button" class="bf-toast__x" data-bf-toast-close aria-label="Close">&times;</button>' +
      '</div>', true);
  }

  /* ---------- add to cart ---------- */
  function initATC() {
    document.querySelectorAll('form[data-bf-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn && btn.classList.contains('is-loading')) return;
        var label = btn ? (btn.querySelector('[data-bf-atc-label]') || btn) : null;
        var original = label ? label.textContent : '';
        var setLabel = function (t) { if (label) label.textContent = t; };
        var reset = function () {
          if (!btn) return;
          btn.classList.remove('is-loading', 'is-added');
          btn.removeAttribute('disabled');
          setLabel(original);
        };

        if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('is-loading'); }
        setLabel('Adding…');

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: (function () {
            var list = [{
              id: form.querySelector('[name="id"]').value,
              quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1
            }];
            form.querySelectorAll('[data-bf-addon]:checked').forEach(function (a) { list.push({ id: a.value, quantity: 1 }); });
            return list;
          })() })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (added) {
            if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); }
            setLabel('Added');
            var mainId = String(form.querySelector('[name="id"]').value);
            var item = added && added.items ? (added.items.filter(function (i) { return String(i.variant_id) === mainId; })[0] || added.items[0]) : added;
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              if (item && cart && cart.items) {
                var k = item.key, vid = item.variant_id, hit = null;
                cart.items.forEach(function (li) { if (!hit && (li.key === k || li.variant_id === vid)) hit = li; });
                if (hit) item = hit;
              }
              return { item: item, cart: cart };
            });
          })
          .then(function (res) {
            document.querySelectorAll('[data-bf-cart-count]').forEach(function (el) { el.textContent = res.cart.item_count; });
            bfShowAdded(res.item, res.cart);
            setTimeout(reset, 1900);
          })
          .catch(function () {
            bfShowError('Could not add to bag — please try again');
            reset();
          });
      });
    });
  }

  /* ---------- sticky mobile bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]');
    var hero = document.querySelector('[data-bf-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(hero);
  }

  /* ---------- lazy video posters ---------- */
  function initReels() {
    var vids = document.querySelectorAll('[data-bf-reel-video]');
    if (!vids.length) return;
    var prime = function (v) {
      if (v.dataset.primed) return;
      v.dataset.primed = '1';
      if (v.src && !/#t=/.test(v.src)) v.src = v.src + '#t=0.1';
      v.preload = 'metadata';
      try { v.load(); } catch (e) {}
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(prime); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { prime(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '300px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- bundle tiers ---------- */
  function initBundle() {
    document.querySelectorAll('[data-bf-bundle]').forEach(function (root) {
      var form = root.closest('form');
      if (!form) return;
      var qty = form.querySelector('[data-bf-bundle-qty]');
      var out = form.querySelector('[data-bf-atc-total]');
      var radios = root.querySelectorAll('input[type="radio"]');
      var paint = function () {
        var unit = parseInt(out ? out.getAttribute('data-unit') : root.getAttribute('data-unit'), 10) || 0;
        radios.forEach(function (r) {
          var q = parseInt(r.value, 10) || 1, pct = parseFloat(r.getAttribute('data-discount')) || 0;
          var lab = r.closest('label');
          var s = lab.querySelector('[data-bf-tier-sale]'), f = lab.querySelector('[data-bf-tier-full]');
          if (s) s.textContent = money(Math.round(unit * q * (1 - pct / 100)));
          if (f) f.textContent = money(unit * q);
        });
      };
      var pick = function () {
        var r = root.querySelector('input:checked');
        if (!r) return;
        if (qty) { qty.value = r.value; }
        if (out) out.setAttribute('data-discount', r.getAttribute('data-discount') || '0');
        if (qty) qty.dispatchEvent(new Event('change', { bubbles: true }));
      };
      try {
        var want = new URL(window.location.href).searchParams.get('bundle');
        if (want) radios.forEach(function (r) { if (r.value === want) r.checked = true; });
      } catch (e) {}
      if (!root.querySelector('input:checked') && radios[0]) radios[0].checked = true;
      radios.forEach(function (r) { r.addEventListener('change', pick); });
      if (out) out.addEventListener('bf:unit', paint);
      pick();
    });
  }

  /* ---------- tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-bf-tabs]').forEach(function (root) {
      root.classList.add('js-tabs');
      var tabs = root.querySelectorAll('[data-bf-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-bf-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          root.querySelectorAll('[data-bf-pane]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bf-pane') === id); });
        });
      });
    });
  }

  /* ---------- delivery estimate ---------- */
  function initEta() {
    document.querySelectorAll('[data-bf-eta]').forEach(function (root) {
      var ds = root.dataset;
      var cut = parseInt(ds.cutoff, 10); if (isNaN(cut)) cut = 14;
      var skip = ds.weekends !== 'true';
      var n = function (k, d) { var v = parseInt(ds[k], 10); return isNaN(v) ? d : v; };
      var isBiz = function (d) { return !skip || (d.getDay() !== 0 && d.getDay() !== 6); };
      var addBiz = function (date, days) { var d = new Date(date); while (days > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) days--; } return d; };
      var loc = document.documentElement.lang || undefined;
      var fmt = function (d) { return d.toLocaleDateString(loc, { month: 'short', day: 'numeric' }); };
      var range = function (a, b) {
        if (a.getTime() === b.getTime()) return fmt(a);
        if (a.getMonth() === b.getMonth()) return fmt(a) + '–' + b.getDate();
        return fmt(a) + ' – ' + fmt(b);
      };
      var deadline = function (now) {
        var d = new Date(now); d.setHours(cut, 0, 0, 0);
        if (now >= d || !isBiz(d)) { do { d.setDate(d.getDate() + 1); } while (!isBiz(d)); }
        return d;
      };
      var h = root.querySelector('[data-eta-h]'), m = root.querySelector('[data-eta-m]'), s = root.querySelector('[data-eta-s]');
      var set = function (el, v) { if (el && el.textContent !== v) { el.textContent = v; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); } };
      var pad = function (x) { return (x < 10 ? '0' : '') + x; };
      var last = '';
      var tick = function () {
        var now = new Date(), dl = deadline(now), left = Math.max(0, dl - now);
        var hh = Math.floor(left / 3.6e6), mm = Math.floor(left % 3.6e6 / 6e4), ss = Math.floor(left % 6e4 / 1e3);
        set(h, pad(hh)); set(m, pad(mm)); set(s, pad(ss));
        var key = dl.toDateString();
        if (key === last) return;
        last = key;
        var base = new Date(dl); base.setHours(0, 0, 0, 0);
        var today = new Date(); today.setHours(0, 0, 0, 0);
        var when = root.querySelector('[data-eta-when]');
        if (when) when.textContent = base.getTime() === today.getTime() ? 'today' : base.toLocaleDateString(loc, { weekday: 'long' });
        var sh = root.querySelector('[data-eta-ship]'), de = root.querySelector('[data-eta-del]');
        if (sh) sh.textContent = range(n('shipMin', 0) ? addBiz(base, n('shipMin', 0)) : base, addBiz(base, n('shipMax', 1)));
        if (de) de.textContent = range(addBiz(base, n('delMin', 3)), addBiz(base, n('delMax', 6)));
      };
      tick(); setInterval(tick, 1000);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { root.classList.add('is-in'); io.disconnect(); } }, { threshold: .4 });
        io.observe(root);
      } else { root.classList.add('is-in'); }
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-bf-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: .2 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- photo reviews arrows ---------- */
  function initPhotoReviews() {
    document.querySelectorAll('[data-bf-pr]').forEach(function (root) {
      var view = root.querySelector('[data-bf-pr-view]');
      if (!view) return;
      var step = function (dir) {
        var c = view.querySelector('.bf-pr__c');
        var w = c ? c.getBoundingClientRect().width + 14 : 300;
        view.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      var p = root.querySelector('[data-bf-pr-prev]'), n = root.querySelector('[data-bf-pr-next]');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- product anatomy hover sync ---------- */
  function initAnatomy() {
    document.querySelectorAll('[data-bf-anat]').forEach(function (root) {
      var all = root.querySelectorAll('[data-bf-anat-i]');
      var hot = function (i) { all.forEach(function (el) { el.classList.toggle('is-hot', el.getAttribute('data-bf-anat-i') === i); }); };
      all.forEach(function (el) {
        var i = el.getAttribute('data-bf-anat-i');
        el.addEventListener('mouseenter', function () { hot(i); });
        el.addEventListener('mouseleave', function () { hot(null); });
        el.addEventListener('focus', function () { hot(i); });
        el.addEventListener('click', function () { hot(i); });
      });
    });
  }

  /* ---------- what it's for — auto-advancing stage ---------- */
  function initUseCases() {
    document.querySelectorAll('[data-bf-uc]').forEach(function (root) {
      var items = root.querySelectorAll('[data-bf-uc-i]'), pics = root.querySelectorAll('[data-bf-uc-pic]');
      var chip = root.querySelector('[data-bf-uc-chip]');
      if (!items.length) return;
      var secs = parseInt(root.getAttribute('data-interval'), 10) || 6;
      root.style.setProperty('--uc-t', secs + 's');
      var cur = 0, timer = null, inView = false, paused = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var show = function (i) {
        cur = i;
        items.forEach(function (el, k) {
          var on = k === i; el.classList.toggle('is-on', on);
          var b = el.querySelector('[role="tab"]'); if (b) b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        pics.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        var u = items[i].querySelector('.bf-uc__use b');
        if (chip) chip.textContent = u ? u.textContent : '';
        schedule();
      };
      var schedule = function () {
        clearTimeout(timer);
        if (reduce || !inView || paused) return;
        timer = setTimeout(function () { show((cur + 1) % items.length); }, secs * 1000);
      };
      items.forEach(function (el, k) {
        var b = el.querySelector('button');
        if (b) b.addEventListener('click', function () { show(k); });
      });
      root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); show(cur); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) show(cur); else clearTimeout(timer); }, { threshold: .35 }).observe(root);
      } else { inView = true; show(0); }
    });
  }

  /* ---------- buy-box problem picker ---------- */
  function initFix() {
    document.querySelectorAll('[data-bf-fix]').forEach(function (root) {
      var chips = root.querySelectorAll('[data-bf-fix-i]'), panes = root.querySelectorAll('[data-bf-fix-pane]');
      var cur = 0, auto = true, timer;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var show = function (i) {
        cur = i;
        chips.forEach(function (c, k) { c.classList.toggle('is-on', k === i); c.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panes.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      };
      chips.forEach(function (c, k) { c.addEventListener('click', function () { auto = false; clearInterval(timer); show(k); }); });
      if (!reduce && chips.length > 1) timer = setInterval(function () { if (auto) show((cur + 1) % chips.length); }, 4200);
    });
  }

  /* ---------- video reels coverflow ---------- */
  function initVideoFlow() {
    document.querySelectorAll('[data-bf-vr]').forEach(function (root) {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bf-vr-i]'));
      var dots = root.querySelectorAll('.bf-vr__dots span');
      if (!cards.length) return;
      var cur = 0, n = cards.length;
      var layout = function () {
        cards.forEach(function (c, i) {
          var o = i - cur;
          if (o > n / 2) o -= n; if (o < -n / 2) o += n;
          c.style.setProperty('--o', o); c.style.setProperty('--a', Math.abs(o));
          c.classList.toggle('is-on', o === 0); c.classList.toggle('is-far', Math.abs(o) > 2);
          var v = c.querySelector('video');
          if (v) { if (o === 0) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); v.muted = true; c.classList.remove('is-sound'); } }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); });
      };
      var go = function (i) { cur = (i + n) % n; layout(); };
      cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
          if (e.target.closest('[data-bf-vr-sound]')) {
            var v = c.querySelector('video'); if (!v) return;
            v.muted = !v.muted; c.classList.toggle('is-sound', !v.muted); if (v.paused) v.play();
            return;
          }
          if (i !== cur) go(i);
        });
      });
      var p = root.querySelector('[data-bf-vr-prev]'), nx = root.querySelector('[data-bf-vr-next]');
      if (p) p.addEventListener('click', function () { go(cur - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
      layout();
    });
  }

  /* ---------- announcement rotator + header state ---------- */
  function initHeaderBits() {
    document.querySelectorAll('[data-bf-ann]').forEach(function (root) {
      var ms = root.querySelectorAll('[data-bf-ann-m]'); if (ms.length < 2) return;
      var secs = parseInt(root.getAttribute('data-interval'), 10) || 4, cur = 0;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setInterval(function () {
        var prev = ms[cur]; prev.classList.remove('is-on'); prev.classList.add('is-out');
        setTimeout(function () { prev.classList.remove('is-out'); }, 650);
        cur = (cur + 1) % ms.length; ms[cur].classList.add('is-on');
      }, secs * 1000);
    });
    var hd = document.querySelector('[data-bf-hd]');
    if (hd) {
      var on = function () { hd.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', on, { passive: true }); on();
      var bt = hd.querySelector('[data-bf-burger]'), nv = hd.querySelector('[data-bf-nav]');
      if (bt && nv && !bt.__bfHd) {
        bt.__bfHd = true;
        bt.addEventListener('click', function () { var o = bt.getAttribute('aria-expanded') !== 'true'; bt.setAttribute('aria-expanded', o ? 'true' : 'false'); nv.classList.toggle('is-open', o); });
      }
    }
    document.addEventListener('bf:cart-updated', function () { document.querySelectorAll('.bf-hd__count').forEach(function (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }); });
  }

  /* ---------- ritual timer ---------- */
  function initRitualTimer() {
    document.querySelectorAll('[data-bf-rt]').forEach(function (root) {
      var ss = root.querySelectorAll('[data-bf-rt-s]'), fs = root.querySelectorAll('[data-bf-rt-face]'), n = ss.length;
      if (!n) return;
      var cur = 0, t, inView = false, paused = false, ms = 3600;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var show = function (i) {
        cur = i; root.style.setProperty('--p', (i + 1) / n);
        ss.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.classList.toggle('is-done', k < i); });
        fs.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
        clearTimeout(t);
        if (!reduce && inView && !paused) t = setTimeout(function () { show((cur + 1) % n); }, ms);
      };
      ss.forEach(function (s, k) { var b = s.querySelector('button'); if (b) b.addEventListener('click', function () { show(k); }); });
      root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(t); });
      root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); show(cur); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) show(cur); else clearTimeout(t); }, { threshold: .3 }).observe(root);
      else { inView = true; show(0); }
    });
  }

  /* ---------- problems tabs ---------- */
  function initProblemTabs() {
    document.querySelectorAll('[data-bf-pb]').forEach(function (root) {
      var grid = root.querySelector('.bf-pb__grid'), tabs = root.querySelectorAll('[data-bf-pb-tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var g = t.getAttribute('data-bf-pb-tab');
          root.setAttribute('data-tab', g); if (grid) grid.setAttribute('data-show', g);
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- home featured gallery ---------- */
  function initHomeFeature() {
    document.querySelectorAll('[data-bf-hmf]').forEach(function (root) {
      var ts = root.querySelectorAll('[data-bf-hmf-t]'), ss = root.querySelectorAll('[data-bf-hmf-s]');
      ts.forEach(function (t) { t.addEventListener('click', function () {
        var i = t.getAttribute('data-bf-hmf-t');
        ts.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        ss.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-bf-hmf-s') === i); });
      }); });
    });
  }

  function boot() {
    initNav(); initGallery(); initQty(); initVariants(); initAtcTotal();
    initElectrodes(); initATC(); initSticky(); initReels(); initBundle(); initTabs(); initEta(); initReveal(); initPhotoReviews(); initAnatomy(); initUseCases(); initFix(); initVideoFlow(); initHeaderBits(); initRitualTimer(); initProblemTabs(); initHomeFeature();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
